import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Compass, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-[70vh] flex items-center justify-center px-6"
      data-testid="page-not-found"
    >
      <Card className="max-w-lg w-full border-slate-200 shadow-sm">
        <CardContent className="p-10 text-center">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-100 text-slate-500">
            <Compass className="h-8 w-8" strokeWidth={1.75} />
          </div>
          <p className="text-sm font-medium uppercase tracking-wide text-slate-400" data-testid="page-not-found-code">
            404
          </p>
          <h1 className="mt-2 text-2xl font-semibold text-slate-900" data-testid="page-not-found-title">
            Seite nicht gefunden
          </h1>
          <p className="mt-3 text-slate-500 leading-relaxed">
            Die angeforderte Seite existiert nicht oder wurde verschoben.
          </p>
          <div className="mt-8 flex items-center justify-center">
            <Button
              onClick={() => navigate('/')}
              className="bg-slate-900 hover:bg-slate-800 text-white gap-2"
              data-testid="page-not-found-home-btn"
            >
              <ArrowLeft className="h-4 w-4" />
              Zurück zum Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
